import React from 'react';
import { InStoreOutlined } from 'jl-design-system/components/icons/InStoreOutlined';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';

export const StoreFinderIcon = () => {
  const handleOnClick = () => {
    sendEvent('nav.mobile.store-finder');
  };

  return (
    <a
      href="/our-shops"
      data-test="store-finder-anchor"
      data-testid="store-finder-anchor"
      aria-label="Store finder"
      onClick={handleOnClick}
    >
      <InStoreOutlined size="large" title="Store Finder" />
    </a>
  );
};
